import { Camera, Clock, Scene, WebGLRenderer } from 'three';
import { Labels } from '../ranges/shared/Labels';

const clock = new Clock();

export class Loop {
  /**
   * @type {Camera}
   */
  #camera;

  /**
   * @type {Scene}
   */
  #scene;

  /**
   * @type {WebGLRenderer}
   */
  #renderer;

  /**
   * @type {array}
   */
  updatables;

  /**
   * @param {Camera} camera
   * @param {Scene} scene
   * @param {WebGLRenderer} renderer
   */
  constructor(camera, scene, renderer) {
    this.#camera = camera;
    this.#scene = scene;
    this.#renderer = renderer;
    this.updatables = [];
  }

  start() {
    this.#renderer.setAnimationLoop(() => {
      this.tick();
      this.#renderer.render(this.#scene, this.#camera);
    });
  }

  stop() {
    this.#renderer.setAnimationLoop(null);
  }

  tick() {
    const delta = clock.getDelta();

    for (const object of this.updatables) {
      object.tick(delta);
    }
  }

  purgeOldLabels() {
    this.updatables = this.updatables.filter((object) => {
      return !(object instanceof Labels);
    });
  }
}
